module.exports = __webpack_public_path__ + "img/post2.9cffb990.png";